/*
 * Author: PMS
 * Title: D1 Form: Draft API Service
 * Description: Page-local service for the Save Draft feature (durable, server-backed).
 *              URLs stay here so the shared UrlService.js does not need changes.
 * Date: 16/08/2026
 */

import useAxiosPrivate from '../../../hooks/useAxiosPrivate';

const serverUrl = process.env.REACT_APP_API_URL;

const useDraftService = () => {
    const axiosPrivate = useAxiosPrivate();

    const saveDraft = async ({ month, year, requisitions }) => {
        try {
            const response = await axiosPrivate.post(
                `${serverUrl}/d1preparation/draft/save`,
                JSON.stringify({ month, year, requisitions }),
                {
                    headers: { 'Content-Type': 'application/json' },
                }
            );
            return response?.data;
        } catch (err) {
            if (!err?.response) {
                console.log('Server Not Responding!');
            } else if (err.response?.status === 401) {
                console.log('Unauthorized!');
            } else {
                console.log('Draft Save Failed!');
            }
            return null;
        }
    };

    const getDrafts = async () => {
        try {
            const response = await axiosPrivate.get(
                `${serverUrl}/d1preparation/draft/list`,
                {
                    headers: { 'Content-Type': 'application/json' },
                }
            );
            return response?.data?.d1_drafts || [];
        } catch (err) {
            if (!err?.response) {
                console.log('Server Not Responding!');
            } else if (err.response?.status === 401) {
                console.log('Unauthorized!');
            } else {
                console.log('Draft List Not Found!');
            }
            return [];
        }
    };

    const deleteDraft = async (id) => {
        try {
            const response = await axiosPrivate.post(
                `${serverUrl}/d1preparation/draft/delete`,
                JSON.stringify({ id }),
                {
                    headers: { 'Content-Type': 'application/json' },
                }
            );
            return response?.data;
        } catch (err) {
            if (!err?.response) {
                console.log('Server Not Responding!');
            } else if (err.response?.status === 401) {
                console.log('Unauthorized!');
            } else {
                console.log('Draft Delete Failed!');
            }
            return null;
        }
    };

    return { saveDraft, getDrafts, deleteDraft };
};

export default useDraftService;
